export enum CouponEvents {
  COUPON_ACTIVATION_FAILURE = 'CouponActivationEventFailure',
  COUPON_ACTIVATION_SUCCESS = 'CouponActivationEventSuccess',
  COUPON_ACTION_EVENT = 'CouponActionEvent',
  COUPON_COMPLETED_EVENT = 'CouponCompletedEvent',
}
